<template>
  <div style="overflow-x: hidden;">
    <b-row>
      <!-- 左侧板块 -->
      <b-col :lg="8">
        <b-row :cols-xs="12">
          <b-col>
            <b-card>
              <b-row>
                <b-col cols="auto" class="mr-auto">
                  <h5>
                    {{ formData.scmName }}
                  </h5>
                  <div class="d-flex">
                    <b-badge class="mr-2" style="font-size: 12px">
                      {{ formData.scmTypeName || 'Not Set' }}
                    </b-badge>
                    <b-badge
                      class="mr-2"
                      style="font-size: 12px"
                      :variant="
                        formData.scmMode === 'B'
                          ? 'primary'
                          : formData.scmMode === 'C'
                          ? 'success'
                          : 'secondary'
                      "
                    >
                      {{ formData.scmModeName || 'Not Set' }}
                    </b-badge>
                    <b-badge class="mr-2" style="font-size: 12px">
                      {{ formData.scmCategoryName || 'Category Not Set' }}
                    </b-badge>
                  </div>
                  <div class="mt-2">
                    <el-rate v-model="formData.ourRatings" disabled> </el-rate>
                  </div>
                </b-col>
                <!-- <b-col cols="auto">
                  <a
                    v-b-toggle.collapse-info
                    role="button"
                    style="color: #606266"
                  >
                    <i
                      v-if="isShowPanel"
                      class="fa fa-chevron-down"
                      title="收起"
                    ></i>
                    <i v-else class="fa fa-chevron-up" title="展开"></i>
                  </a>
                </b-col> -->
              </b-row>
              <b-collapse v-model="isShowPanel" id="collapse-info">
                <div class="mt-2" style="font-size: 14px; color:#666666">
                  <el-row :gutter="5">
                    <el-col :span="24">
                      <span>
                        {{ formData.provinceName || '' }}
                        {{ formData.cityName || '' }}
                        {{ formData.districtName || '' }}
                        {{ formData.scmAddress || '' }}</span
                      >
                    </el-col>
                  </el-row>
                  <el-row class="mt-2" :gutter="5">
                    <el-col :span="24">
                      <span
                        >统一社会征信代码：{{
                          formData.businessLicense || ''
                        }}</span
                      >
                    </el-col>
                  </el-row>
                  <el-row class="mt-2" :gutter="5">
                    <el-col
                      :span="12"
                      v-for="(item, index) in formData.scmInfoBankList"
                      :key="index"
                    >
                      <el-row class="mt-2" :gutter="5">
                        <el-col :span="24">
                          <span> 开户银行 ：{{ item.bankName || '' }}</span>
                        </el-col>
                        <el-col :span="24">
                          <span>
                            账户名称：{{ item.bankAccountName || '' }}</span
                          >
                        </el-col>
                        <el-col :span="24">
                          <span>
                            银行账号 ：{{ item.bankAccountNo || '' }}</span
                          >
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>

                  <el-row class="mt-2" :gutter="5">
                    <el-col :span="24">
                      <span
                        >相关证书：{{ formData.certificateInfo || '' }}</span
                      >
                    </el-col>
                    <el-col :span="24">
                      <span
                        >工厂资质：{{ formData.factoryInspection || '' }}</span
                      >
                    </el-col>
                    <el-col :span="24">
                      <span
                        >适用客户：{{
                          formData.suitableForCustomers || ''
                        }}</span
                      >
                    </el-col>
                    <!-- <el-col :span="12">
                  <span
                    >{{ $l('form_label_supplier_source') || '供应商来源' }}：{{
                      formData.scmSource || ''
                    }}</span
                  >
                </el-col> -->
                  </el-row>
                  <el-row class="mt-2" :gutter="5" v-if="formData.scmMemo">
                    <el-col :span="24">
                      <span style="font-weight:500;">工厂概况：</span>
                    </el-col>
                    <el-col :span="24">
                      <span v-html="formData.scmMemo || ''"></span>
                    </el-col>
                  </el-row>
                  <el-row
                    class="mt-2"
                    :gutter="5"
                    v-if="formData.scmProductCategory"
                  >
                    <el-col :span="24">
                      <span style="font-weight:500;">
                        主要品类：
                      </span>
                    </el-col>
                    <el-col :span="24">
                      <span v-html="formData.scmProductCategory || ''"></span>
                    </el-col>
                  </el-row>
                  <el-row
                    class="mt-2"
                    :gutter="5"
                    v-if="formData.scmCooperation"
                  >
                    <el-col :span="24">
                      <span style="font-weight:500;">
                        合作意向：
                      </span>
                    </el-col>
                    <el-col :span="24">
                      <span v-html="formData.scmCooperation || ''"> </span>
                    </el-col>
                  </el-row>
                </div>
              </b-collapse>
            </b-card>
          </b-col>

          <!-- 联系人信息 -->
          <b-col :lg="12">
            <contacts
              ref="contacts"
              :params="contactsParams"
              :autoLoad="true"
            />
          </b-col>

          <!-- 厂商图片 -->
          <b-col :lg="12">
            <scm-images
              ref="scmImages"
              :params="scmImagesParams"
              :autoLoad="true"
            />
          </b-col>
          <!-- 厂商文件 -->
          <b-col :lg="12">
            <scm-files ref="scmFiles" :params="scmImagesParams" />
          </b-col>
          <!-- 拜访记录 -->
          <b-col :lg="12">
            <visit ref="visit" :params="visitParams" :autoLoad="true" />
          </b-col>
        </b-row>
      </b-col>

      <!-- 右侧版块 -->
      <b-col :lg="4">
        <b-row>
          <!-- 厂商评分 -->
          <b-col :lg="12">
            <rating ref="rating" :params="ratingParams" :autoLoad="true" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import contacts from './components/contacts'
import rating from './components/rating'
import scmImages from './components/scmimages'
import scmFiles from './components/scmimages/file.vue'
import visit from './components/visit'
export default {
  name: 'opview-scm-info',
  components: { contacts, rating, scmImages, scmFiles, visit },
  data() {
    return {
      formData: {
        scmCode: '',
        scmNo: '',
        scmName: '',
        scmNameEn: '',
        scmStatus: '',
        scmStatusName: '',
        scmAddress: '',
        scmMemo: '',
        createBy: '',
        createByName: '',
        createDate: '',
        modifyBy: '',
        modifyByName: '',
        modifyDate: '',
        scmCategoryCode: '',
        scmCategoryName: '',
        scmCooperation: '',
      },
      isShowPanel: true,
      curParam: {
        scmCode: '',
      },
    }
  },

  // 侦听器
  watch: {
    '$route.params'() {
      if (this.$route.params.code) {
        this.formLoad()
      }
    },
  },

  mounted() {
    document.body.scrollTop = 0
    this.formLoad()
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f1f1f1;')
  },

  computed: {
    ratingParams() {
      return {
        scmCode: this.formData.scmCode,
      }
    },
    contactsParams() {
      return {
        scmCode: this.formData.scmCode,
      }
    },
    scmImagesParams() {
      return {
        scmCode: this.formData.scmCode,
      }
    },
    visitParams() {
      return {
        scmCode: this.formData.scmCode,
      }
    },
  },

  methods: {
    formLoad() {
      let scmCode = this.$route.params.code
      this.curParam.scmCode = scmCode
      this.contactsParams.scmCode = scmCode
      this.ratingParams.scmCode = scmCode
      this.scmImagesParams.scmCode = scmCode
      this.visitParams.scmCode = scmCode
      this.refresh()
    },

    refresh() {
      let param = { scmCode: this.curParam.scmCode }
      this.$api.opaScmOaViewDetailApi(param).then((res) => {
        this.formData = res.body
        this.contactsParams.scmCode = this.formData.scmCode
        this.ratingParams.scmCode = this.formData.scmCode
        this.scmImagesParams.scmCode = this.formData.scmCode
        this.visitParams.scmCode = this.formData.scmCode
        if (this.formData.scmMemo !== null) {
          this.formData.scmMemo = this.formData.scmMemo
            .replace(/ /g, '&nbsp;')
            .replace(/\n/g, '<br/>')
        }
        if (this.formData.scmCooperation !== null) {
          this.formData.scmCooperation = this.formData.scmCooperation
            .replace(/ /g, '&nbsp;')
            .replace(/\n/g, '<br/>')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  margin: 20px 10px;
}
</style>
